import React, { useMemo } from "react";
import { StatusBadge as StatusBadgeEnum } from "@shared/constants";
import { useTranslation } from "@shared/utils/internationalization";

import StatusBadge from "../StatusBadge/StatusBadge.web";

// TODO move elsewhere or get from backend
export enum PROTECTION_POLICY_STATUS_MAP {
  CREATED = "ps_created",
  VOIDED = "ps_voided",
  ISSUED = "ps_issued",
  ON_HOLD = "ps_on_hold",
  DOWNGRADED = "ps_downgraded",
  UPGRADED = "ps_upgraded",
  EXCHANGED = "ps_exchanged",
  CANCELED = "ps_canceled",
}

type ProtectionPolicyStatusBadgeProps = {
  policy_status: PROTECTION_POLICY_STATUS_MAP;
};

const PROTECTION_POLICY_STATUS_BADGE_COLOR_MAP = {
  [PROTECTION_POLICY_STATUS_MAP.CREATED]: StatusBadgeEnum.warning, // "Created" can falsely portray a protected item, so make this a warning.
  [PROTECTION_POLICY_STATUS_MAP.VOIDED]: StatusBadgeEnum.error,
  [PROTECTION_POLICY_STATUS_MAP.ISSUED]: StatusBadgeEnum.success,
  [PROTECTION_POLICY_STATUS_MAP.ON_HOLD]: StatusBadgeEnum.warning,
  [PROTECTION_POLICY_STATUS_MAP.DOWNGRADED]: StatusBadgeEnum.info,
  [PROTECTION_POLICY_STATUS_MAP.UPGRADED]: StatusBadgeEnum.info,
  [PROTECTION_POLICY_STATUS_MAP.EXCHANGED]: StatusBadgeEnum.info,
  [PROTECTION_POLICY_STATUS_MAP.CANCELED]: StatusBadgeEnum.error,
};

export const ProtectionPolicyStatusBadge = ({
  policy_status,
}: React.PropsWithChildren<ProtectionPolicyStatusBadgeProps>) => {
  const { t } = useTranslation("common");

  const PROTECTION_POLICY_STATUS_BADGE_NAME_MAP = useMemo(() => {
    return {
      [PROTECTION_POLICY_STATUS_MAP.CREATED]: t("Created"),
      [PROTECTION_POLICY_STATUS_MAP.VOIDED]: t("Voided"),
      [PROTECTION_POLICY_STATUS_MAP.ISSUED]: t("Protected"),
      [PROTECTION_POLICY_STATUS_MAP.ON_HOLD]: t("On hold"),
      [PROTECTION_POLICY_STATUS_MAP.DOWNGRADED]: t("Downgraded"),
      [PROTECTION_POLICY_STATUS_MAP.UPGRADED]: t("Upgraded"),
      [PROTECTION_POLICY_STATUS_MAP.EXCHANGED]: t("Exchanged"),
      [PROTECTION_POLICY_STATUS_MAP.CANCELED]: t("Canceled"),
    };
  }, [t]);

  return (
    <StatusBadge
      status={PROTECTION_POLICY_STATUS_BADGE_COLOR_MAP[policy_status]}
    >
      {PROTECTION_POLICY_STATUS_BADGE_NAME_MAP[policy_status]}
    </StatusBadge>
  );
};
